import dynamic from "next/dynamic";

export const OfficeCards = dynamic(() => import("./component"));
